import { ReactNode } from "react";

export interface IModalProps {
  onAcceptHandler?: () => void;
  onCancelHandler?: () => void;
  title: string;
  hideAcceptButton?: boolean;
  warningText?: string;
  open: boolean;
  primaryColor?: string;
  secondaryColor?: string;
  children: ReactNode;
}

export interface IModalConfiguration {
  title: string;
  warningText?: string;
  hideAcceptButton: boolean;
}

export const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  alignText: "center",
  transform: "translate(-50%, -50%)",
  width: 514,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: "26px",
  borderRadius: "10px",
};
